import _taggedTemplateLiteral from "/home/shgbit/space365-apps/default/universal/space/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";
import _regeneratorRuntime from "/home/shgbit/space365-apps/default/universal/space/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator";
import _asyncToGenerator from "/home/shgbit/space365-apps/default/universal/space/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _classCallCheck from "/home/shgbit/space365-apps/default/universal/space/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/shgbit/space365-apps/default/universal/space/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n\t\t  {\n\t\t\t\tme{\n\t\t\t\t\tlang\n\t\t\t\t}\n\t\t\t}\n\t\t"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var debug = require('debug')('shgbit:space');

var axios = require('axios');

var qs = require('qs');

var config = require('./config').default;

var _ = require('lodash');

import ApolloClient from 'apollo-boost';
import { gql } from 'apollo-boost';

var OAuth =
/*#__PURE__*/
function () {
  function OAuth(args) {
    _classCallCheck(this, OAuth);

    var idOrigin = config.getAuthOrigin();
    var backendOrigin = config.getBackendOrigin();
    this.authorizeEndpoint = "".concat(idOrigin, "/oauth/authorize");
    this.tokenEndpoint = "".concat(idOrigin, "/oauth/token");
    this.tokenInfoEndpoint = "".concat(backendOrigin, "/oauth/tokeninfo");
    this.callbackEndpoint = "".concat(backendOrigin, "/oauth/callback");
    this.logoutEndpoint = "".concat(idOrigin, "/oauth/logout");
    this.grantType = args.grantType || 'authorization_code'; // client_id

    this.clientId = args.clientId; // client_secret

    this.secret = args.secret; // device_id

    this.deviceId = args.deviceId;
    this.defaultLang = args.defaultLang;
    this.apolloClient = this.createApolloClient();
  }

  _createClass(OAuth, [{
    key: "token",
    value: function () {
      var _token = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee() {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!('device_credentials' === this.grantType)) {
                  _context.next = 4;
                  break;
                }

                _context.next = 3;
                return this.deviceFlow();

              case 3:
                return _context.abrupt("return", _context.sent);

              case 4:
                _context.next = 6;
                return this.authCodeFlow();

              case 6:
                return _context.abrupt("return", _context.sent);

              case 7:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function token() {
        return _token.apply(this, arguments);
      }

      return token;
    }()
  }, {
    key: "lang",
    value: function () {
      var _lang = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee2() {
        var lang, browserLang, localStorageLang, data;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                lang = 'zh-CN';
                browserLang = navigator.language || navigator.userLanguage; // 根据LocalStorage.username判定是否已登录

                if (localStorage.getItem('username')) {
                  localStorageLang = localStorage.getItem('lang');
                  lang = localStorageLang || browserLang;
                } else {
                  if (this.defaultLang) {
                    lang = this.defaultLang;
                  } else {
                    lang = browserLang;
                  }
                } // 非法语言时默认英文


                if (lang !== 'zh-CN' && lang !== 'en-US' && lang != 'en-GB') lang = 'en-US';
                _context2.next = 6;
                return this.query(gql(_templateObject()));

              case 6:
                data = _context2.sent;

                if (data && data.me && data.me.lang) {
                  lang = data.me.lang;
                }

                return _context2.abrupt("return", lang);

              case 9:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function lang() {
        return _lang.apply(this, arguments);
      }

      return lang;
    }()
  }, {
    key: "query",
    value: function () {
      var _query2 = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee3(_query, variables) {
        var result;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return this.apolloClient.query({
                  query: _query,
                  variables: variables,
                  fetchPolicy: 'no-cache'
                });

              case 2:
                result = _context3.sent;
                return _context3.abrupt("return", result.data);

              case 4:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function query(_x, _x2) {
        return _query2.apply(this, arguments);
      }

      return query;
    }()
  }, {
    key: "createApolloClient",
    value: function createApolloClient() {
      var _this = this;

      var result = new ApolloClient({
        uri: "".concat(config.getBackendOrigin(), "/graphql"),
        request: function () {
          var _request = _asyncToGenerator(
          /*#__PURE__*/
          _regeneratorRuntime.mark(function _callee4(operation) {
            return _regeneratorRuntime.wrap(function _callee4$(_context4) {
              while (1) {
                switch (_context4.prev = _context4.next) {
                  case 0:
                    operation.setContext({
                      headers: {
                        Authorization: _this.token ? "Bearer ".concat(_this.token) : ''
                      }
                    });

                  case 1:
                  case "end":
                    return _context4.stop();
                }
              }
            }, _callee4);
          }));

          function request(_x3) {
            return _request.apply(this, arguments);
          }

          return request;
        }()
      });
      return result;
    }
  }, {
    key: "deviceFlow",
    value: function () {
      var _deviceFlow = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee5() {
        var response;
        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                debug('oauth: run client flow');
                debug('window.location:', window.location.href);
                debug(this.tokenEndpoint);
                _context5.next = 5;
                return axios.post(this.tokenEndpoint, {
                  grant_type: 'device_credentials',
                  client_id: this.clientId,
                  client_secret: this.secret,
                  device_id: this.deviceId
                });

              case 5:
                response = _context5.sent;
                return _context5.abrupt("return", response.data.access_token);

              case 7:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));

      function deviceFlow() {
        return _deviceFlow.apply(this, arguments);
      }

      return deviceFlow;
    }()
  }, {
    key: "authCodeFlow",
    value: function () {
      var _authCodeFlow = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee6() {
        var t, _url, response, callback, url;

        return _regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                debug('begin get token');
                debug('window.location:', window.location.href);
                t = _(qs.parse(window.location.href)).values().last();

                if (!t) {
                  _context6.next = 15;
                  break;
                }

                // go ahead
                this.token = t; // check token available

                _url = "".concat(this.tokenInfoEndpoint, "?token=").concat(this.token);
                _context6.prev = 6;
                _context6.next = 9;
                return axios.get(_url);

              case 9:
                response = _context6.sent;
                return _context6.abrupt("return", this.token);

              case 13:
                _context6.prev = 13;
                _context6.t0 = _context6["catch"](6);

              case 15:
                // goto login
                callback = "".concat(this.callbackEndpoint, "?redirect=").concat(encodeURIComponent(window.location.href));
                url = "".concat(this.authorizeEndpoint, "?grant_type=authorization_code&client_id=").concat(this.clientId, "&redirect_uri=").concat(encodeURIComponent(callback));
                debug(url);
                window.location = url;

              case 19:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, this, [[6, 13]]);
      }));

      function authCodeFlow() {
        return _authCodeFlow.apply(this, arguments);
      }

      return authCodeFlow;
    }()
  }, {
    key: "logout",
    value: function logout() {
      window.location = "".concat(config.getAuthOrigin(), "/oauth/logout");
    }
  }, {
    key: "profile",
    value: function profile() {
      window.location = "".concat(config.getAuthOrigin(), "/oauth/profile?token=").concat(this.token);
    }
  }]);

  return OAuth;
}();

export { OAuth as default };